import React from 'react';
import { Dialog, DialogContent, Slide  } from 'src/components';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export default function MapDialogMobile({ children, isExpanded, toggleIsExpanded }) {
    return (
        <Dialog
            open={isExpanded}
            onClose={toggleIsExpanded}
            TransitionComponent={Transition}
            keepMounted 
            fullScreen>

                <DialogContent>
                    {children}
                </DialogContent>

        </Dialog>
    );
}